<template>
  <div id="hero"
      class="destination-hero push-v--desktop--small push-v--tablet--small push-v--mobile--small"
  >
    <section class="destination-hero__content">
      <section class="destination-hero__title-wrapper">
        <h1 class="destination-hero__title">{{ title }}<br><span>{{ subtitle }}</span></h1>
        <div class="destination-hero__shape" />
      </section>
      <article ref="galleryParent" class="destination-hero__gallery-parent">
        <div ref="gallery" class="destination-hero__gallery">
          <AnimatedGallery :images="gallery" :class="`destination-hero__gallery`" />
        </div>
        <section class="destination-hero__arrow" @click="scrollBelow">
          <ArrowIcon class="destination-hero__arrow-icon" />
          <!-- <div class="destination-hero__arrow-icon" /> -->
        </section>
      </article>
    </section>
  </div>
</template>
<script>
// import ShapeDestinationHero from '~/components/elements/ShapeDestinationHero.vue';
import AnimatedGallery from '~/components/components/AnimatedGallery.vue';
import ArrowIcon from '~/assets/icons/new/dark/arrow-down.svg?inline';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { gsap, CSSPlugin } from 'gsap';
export default {
  components: { AnimatedGallery, ArrowIcon },
  props: {
    title: { type: String, default: '', required: true },
    subtitle: { type: String, default: '', required: true },
    gallery: { type: Array, default: null, required: false },
  },
  data() {
    return {
      tl: null,
      isScrolling: false,
    };
  },
  mounted() {
    // const { gallery } = this.$refs;
    gsap.registerPlugin(CSSPlugin);
    gsap.registerPlugin(ScrollTrigger);


    // gsap.to(galleryParent, {
    //   x: -(galleryParent.offsetWidth - window.innerWidth),
    //   // duration: 3,
    //   scrollTrigger: {
    //     trigger: galleryParent,
    //     scrub: true,
    //   },
    // });

    // this.tl = new TimelineLite({
    //   defaults: { // children inherit these defaults
    //     ease: 'none',
    //   },
    //   smoothChildTiming: true,
    //   autoRemoveChildren: true,
    //   onComplete: function() {
    //     // gallery.parentNode.appendChild(gallery.cloneNode);
    //   },
    // });
    // this.tl.to(gallery, { x: -400, duration: 10, ease: 'linear', repeat: -1, yoyo: true });
    // this.tl.to(gallery, { x: -800, duration: 10, ease: 'none', scrollTrigger: {
    //   trigger: galleryParent,
    //   scrub: true,
    // } });


  },
  methods: {
    scrollBelow() {
      const ele = document.querySelector('.destination-intro');
      ele && ele.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  },
};
</script>
<style lang="scss">
@import '~/assets/scss/atomic/modules/_destination-hero.scss';
</style>
